"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchSonarTaskTemplateConfig = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.patchSonarTaskTemplateConfig = (0, sonar_http_1.createPatchEndpoint)((request) => `/api/v3/core/organizations/${request.organizationId}/tasks/${request.taskType}/config`, {
    headers: (request) => {
        if (request === null || request === void 0 ? void 0 : request.shardName) {
            return { [sonar_http_1.HttpHeader.Shard]: request.shardName };
        }
        return {};
    },
    requestTransform: (request) => ({
        enabled: request.enabled,
        minDaysInterval: request.minDaysInterval
    })
});
//# sourceMappingURL=patchSonarTaskTemplateConfig.js.map